import CRUD from '../base/crud'

class DevicesCRUD extends CRUD {
  getDevices(params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/devices`,
      params,
    })
  }

  deleteDevice(id) {
    return this.request({
      method: 'DELETE',
      url: `${this.url}/devices/${id}`,
    })
  }

  updateDevice(id, data) {
    return this.request({
      method: 'PUT',
      url: `${this.url}/devices/${id}`,
      data,
    })
  }

  createDevice(data) {
    return this.request({
      method: 'POST',
      url: `${this.url}/devices`,
      data,
    })
  }

  getPanel(params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/panels`,
      params,
    })
  }

  updatePanel(id, data) {
    return this.request({
      method: 'PATCH',
      url: `${this.url}/panels/${id}`,
      data,
    })
  }

  getAdminProfile(params) {
    return this.request({
      url: `${this.url}/profile`,
      params,
    })
  }

  getMeterToChannelMappingList(id, params) {
    return this.request({
      url: `${this.url}/devices/mapping/list/${id}`,
      params,
    })
  }

  deviceMappingCreate(data, params) {
    return this.request({
      url: `${this.url}/devices/mapping`,
      method: 'POST',
      data,
      params,
    })
  }
}

export default function devicesCRUD(request) {
  return new DevicesCRUD({
    url: '/admin',
    request,
  })
}
